import ClockType from "../enums/clock-type";
import FieldLength from "../enums/field-length";
import GoalPost from "../enums/goal-post";
import KickoffSkip from "../enums/kickoff-skip";
import PatPoints from "../enums/pat-points";
import TeamLoss from "../enums/team-loss";
import ParticipationStyle from "../enums/participation-style";

const DefaultCflConfig = Object.freeze({
    general: {
        periodsInRegulation: 4,
        downs: 3,
        fieldLength: FieldLength.OptionEight.code,
        fieldWidth: 65,
        minutesByPeriod: 15,
        firstDownYards: 10,
        // TODO: this property shouldn't be here. This is part of the flag config.
        firstDownFlagStyle: -1,
        timeoutsPerHalf: 2,
        // PSTATS-1268, see config/default.js. Needs Verification against the
        // CFL rulebook's overtime timeouts.
        otTimeouts: 1,
        redZoneLength: 20,
        zoneLength: 20,
        endZoneLength: 20,
        includeEndZoneYardage: true,
        otTimeControl: false,
        // PSTATS-1268, see config/default.js.
        otMinutesByPeriod: 10,
        autoFairCatchTb: false,
        rushType: false,
        passType: false,
        spikeTeamAttOnly: false,
        touchdownsCountAsFirstDowns: false,
        teamLossOnly: [TeamLoss.KneelDown.code, TeamLoss.Sack.code],
        collectStatsOnPat: true,
        collectStatsForOnSideKicks: false,
        teamZoneQty: 1,
        promptToSkipKickoff: [
            KickoffSkip.Safety.code,
            KickoffSkip.FieldGoal.code
        ],
        participationStyle: ParticipationStyle.Default.code
    },
    clock: {
        clockType: ClockType.ASC.code,
        runningClock: false
    },
    spots: {
        kickoff: 45,
        KOTouchback: 20,
        otherTouchback: 20,
        PATTry: 5,
        safetyKO: 35,
        driveStartingYardline: 35,
        touchbackYardline: 20,
        rougeYardline: 35,
        // PSTATS-1268, see config/default.js.
        otKickoffs: false,
        overtimeStartingYardline: 35,
        spotsPatScoreOption1: 5,
        spotsPatScoreOption2: 10,
        spotsPatScoreOption3: 20,
        goalPostLocation: GoalPost.GOAL_LINE.code
    },
    scoring: {
        touchdown: 6,
        kickPAT: 1,
        runPAT: 2,
        safety: 2,
        rougePoints: 1,
        fieldGoal: 3,
        defensivePAT: 2,
        scoringPatScoreOption1: PatPoints.OptionOne.value,
        scoringPatScoreOption2: PatPoints.OptionTwo.value,
        scoringPatScoreOption3: PatPoints.OptionThree.value,
        playSummary: true
    }
});

export default DefaultCflConfig;
